import { Utilities } from "../../../utils/utilities";
import { FirebaseInfoField } from "../General/FirebaseInfoField";
import { LocalData } from "../General/LocalData";
import { PropertyData } from "./PropertyData";

export class PropertyInfoFields {
  static loadFields(property: PropertyData, data: { [key: string]: any }) {
    for (const [key, infoField] of Object.entries(data)) {
      if (typeof infoField === "object") {
        const value = infoField.value;
        if (key === "location") {
          property.location = new FirebaseInfoField(value, infoField);
        } else if (key === "address" && typeof value === "string") {
          property.address = new FirebaseInfoField(value, infoField);
        } else if (key === "visitorAddress" && typeof value === "string") {
          property.visitorAddress = new FirebaseInfoField(value, infoField);
        } else if (key === "postalAddress" && typeof value === "string") {
          property.postalAddress = new FirebaseInfoField(value, infoField);
        } else if (key === "city" && typeof value === "string") {
          property.city = new FirebaseInfoField(value, infoField);
        } else if (key === "municipality" && typeof value === "string") {
          property.municipality = new FirebaseInfoField(value, infoField);
        } else if (key === "municipalityNumber" && typeof value === "string") {
          property.municipalityNumber = new FirebaseInfoField(value, infoField);
        } else if (key === "gnr" && typeof value === "string") {
          property.gnr = new FirebaseInfoField(value, infoField);
        } else if (key === "bnr" && typeof value === "string") {
          property.bnr = new FirebaseInfoField(value, infoField);
        } else if (key === "snr" && typeof value === "string") {
          property.snr = new FirebaseInfoField(value, infoField);
        } else if (key === "floors" && Array.isArray(value)) {
          property.floors = new FirebaseInfoField(value, infoField);
        } else if (key === "totalParkingSpots" && typeof value === "number") {
          property.totalParkingSpots = new FirebaseInfoField(value, infoField);
        } else if (key === "constructionYear" && typeof value === "string") {
          property.constructionYear = new FirebaseInfoField(value, infoField);
        } else if (key === "plotArea" && typeof value === "number") {
          property.plotArea = new FirebaseInfoField(value, infoField);
        } else if (key === "totalArea" && typeof value === "number") {
          property.totalArea = new FirebaseInfoField(value, infoField);
        } else if (key === "usageArea" && typeof value === "number") {
          property.usageArea = new FirebaseInfoField(value, infoField);
        } else if (key === "builtArea" && typeof value === "number") {
          property.builtArea = new FirebaseInfoField(value, infoField);
        } else if (key === "netArea" && typeof value === "number") {
          property.netArea = new FirebaseInfoField(value, infoField);
        } else if (key === "primaryArea" && typeof value === "number") {
          property.primaryArea = new FirebaseInfoField(value, infoField);
        } else if (key === "secondaryArea" && typeof value === "number") {
          property.secondaryArea = new FirebaseInfoField(value, infoField);
        } else if (key === "rentableArea" && typeof value === "number") {
          property.rentableArea = new FirebaseInfoField(value, infoField);
        } else if (key === "jointArea" && typeof value === "number") {
          property.jointArea = new FirebaseInfoField(value, infoField);
        } else if (key === "ownedArea" && typeof value === "number") {
          property.ownedArea = new FirebaseInfoField(value, infoField);
        } else if (key === "rentedArea" && typeof value === "number") {
          property.rentedArea = new FirebaseInfoField(value, infoField);
        } else if (key === "heatedArea" && typeof value === "number") {
          property.heatedArea = new FirebaseInfoField(value, infoField);
        } else if (key === "buildingOwner" && typeof value === "string") {
          property.buildingOwner = new FirebaseInfoField(value, infoField);
        } else if (key === "architects" && typeof value === "string") {
          property.architects = new FirebaseInfoField(value, infoField);
        } else if (key === "managementCompanies" && typeof value === "string") {
          property.managementCompanies = new FirebaseInfoField(value, infoField);
        } else if (key === "insuranceCompanies" && typeof value === "string") {
          property.insuranceCompanies = new FirebaseInfoField(value, infoField);
        } else if (key === "fireSafetyResponsibles" && Array.isArray(value)) {
          property.fireSafetyResponsibles = new FirebaseInfoField(
            value.map((id) => LocalData.users.addData(id + "")),
            infoField
          );
        } else if (key === "riskClass" && typeof value === "string") {
          property.riskClass = new FirebaseInfoField(value, infoField);
        } else if (key === "fireClass" && typeof value === "string") {
          property.fireClass = new FirebaseInfoField(value, infoField);
        } else if (key === "energyScore" && typeof value === "string") {
          property.energyScore = new FirebaseInfoField(value, infoField);
        } else if (key === "heatingScore" && typeof value === "string") {
          property.heatingScore = new FirebaseInfoField(value, infoField);
        } else if (key === "protectionClass" && typeof value === "string") {
          property.protectionClass = new FirebaseInfoField(value, infoField);
        } else if (key === "maxPeopleAllowed" && typeof value === "number") {
          property.maxPeopleAllowed = new FirebaseInfoField(value, infoField);
        } else if (key === "jointCost" && typeof value === "number") {
          property.jointCost = new FirebaseInfoField(value, infoField);
        } else if (key === "totalJointCost" && typeof value === "number") {
          property.totalJointCost = new FirebaseInfoField(value, infoField);
        } else if (key === "marketValue" && typeof value === "number") {
          property.marketValue = new FirebaseInfoField(value, infoField);
        } else if (key === "balanceSheetValue" && typeof value === "number") {
          property.balanceSheetValue = new FirebaseInfoField(value, infoField);
        } else if (key === "grossYield" && typeof value === "number") {
          property.grossYield = new FirebaseInfoField(value, infoField);
        } else if (key === "purchaseDate") {
          property.purchaseDate = new FirebaseInfoField(Utilities.getDateFromTimestamp(value), infoField);
        } else if (key === "purchaseSum" && typeof value === "number") {
          property.purchaseSum = new FirebaseInfoField(value, infoField);
        } else if (key === "initialLoan" && typeof value === "number") {
          property.initialLoan = new FirebaseInfoField(value, infoField);
        } else if (key === "remainingLoan" && typeof value === "number") {
          property.remainingLoan = new FirebaseInfoField(value, infoField);
        } else if (key === "note" && typeof value === "string") {
          property.note = new FirebaseInfoField(value, infoField);
        } else if (key === "organizationNumber" && typeof value === "string") {
          property.organizationNumber = new FirebaseInfoField(value, infoField);
        } else if (key === "organizationName" && typeof value === "string") {
          property.organizationName = new FirebaseInfoField(value, infoField);
        }
      }
    }
  }
}

